import React, {useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import AvatarEditor from 'react-avatar-editor';
import { Button } from '@material-ui/core';

function rand() {
    return Math.round(Math.random() * 20) - 10;
  }
  
  function getModalStyle() {
    const top = 50 + rand();
    const left = 50 + rand();
  
    return {
      top: `${top}%`,
      left: `${left}%`,
      transform: `translate(-${top}%, -${left}%)`,
    };
  }

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

export default function CroppableImage(props) {
  const classes = useStyles();
  // getModalStyle is not a pure function, we roll the style only on the first render
  const [modalStyle] = useState(getModalStyle);
  const [open, setOpen] = useState(props.open);
  const [editor, setEditor] = useState(null);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false); 
  };

  const setEditorRef = (editor) => {
    setEditor(editor)
  }

  const onClickSave = () => {
    if (editor) {
      // This returns a HTMLCanvasElement, it can be made into a data URL or a blob,
      // drawn on another canvas, or added to the DOM.
      const canvas = editor.getImage()
 
    //   // If you want the image resized to the canvas size (also a HTMLCanvasElement)
      const canvasScaled = editor.getImageScaledToCanvas()
      props.onSave(canvasScaled.toDataURL())
      props.close() 
    }
  }

  return (
    <div>
      <Modal
        open={props.open}
        onClose={props.close}
        aria-labelledby={props.labelModal}
        aria-describedby={props.labelDes}
      >
        <div style={modalStyle} className={classes.paper}>
            <Button onClick={() => onClickSave()}>Save</Button>
            <AvatarEditor
                ref={(editor12) => setEditor(editor12)}
                image={props.media}
                width={250}
                height={250}
                // border={50}
                borderRadius={ props.isAvatar ? 125 : 0 }
                color={[255, 255, 255, 0.6]} // RGBA
                scale={1.2}
                rotate={0}
                crossOrigin="anonymous"
            />
        </div>
      </Modal>
    </div>
  );
}